import { EntityConfig } from '@components-fabric';
import {
  Material,
  MaterialForm,
  getMaterialValidationSchema,
} from '@components-domain/bim';

export const materialEntity: EntityConfig<Material> = {
  id: 'materials',
  columns: ['id', 'name', 'description', 'class'],
  endpoints: '/buildingsms/materials',
  name: 'Materials',
  formComponent: MaterialForm,
  schema: getMaterialValidationSchema(),
  empty: {
    class: 'CONCRETE',
    name: '',
    description: '',
    sourceType: 'SYSTEM',
    sourceId: 'ad51df0b-d35ws0-4fd6-a7cb-904a938e7bbb',
    modifiedDate: new Date(Date.now()),
    createdDate: new Date(Date.now()),
  },
};
